module.exports = __webpack_public_path__ + "static/media/fa-solid-900.5229fc2d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-solid-900.woff2
// module id = 302
// module chunks = 0